import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Don't show cookie consent on client resource pages
    if (window.location.pathname.startsWith('/client/')) {
      return;
    }
    
    const hasConsented = localStorage.getItem('resiligent_cookie_consent');
    if (!hasConsented) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('resiligent_cookie_consent', 'all');
    localStorage.setItem('resiligent_cookie_consent_date', new Date().toISOString());
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('resiligent_cookie_consent', 'declined');
    localStorage.setItem('resiligent_cookie_consent_date', new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px'
      }}
    >
      <div 
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          maxWidth: '480px',
          width: '100%',
          padding: '32px'
        }}
      >
        {/* Icon */}
        <div 
          style={{
            width: '48px',
            height: '48px',
            backgroundColor: 'rgba(38, 147, 208, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px'
          }}
        >
          <svg width="24" height="24" fill="none" stroke="#2693d0" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        
        <h2 style={{ color: '#0f172a', fontWeight: 600, fontSize: '20px', marginBottom: '12px' }}>
          We value your privacy
        </h2>
        
        <p style={{ color: '#475569', fontSize: '15px', lineHeight: 1.6, marginBottom: '24px' }}>
          We use cookies to enhance your browsing experience, analyse site traffic, and understand where our visitors come from. Please choose whether to accept or decline cookies.
        </p>
        
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}>
          <button
            onClick={handleAccept}
            style={{
              backgroundColor: '#2693d0',
              color: '#ffffff',
              padding: '14px 24px',
              borderRadius: '8px',
              fontWeight: 500,
              fontSize: '15px',
              border: 'none',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1e7ab8'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#2693d0'}
          >
            Accept All Cookies
          </button>
          <button
            onClick={handleDecline}
            style={{
              backgroundColor: '#ffffff',
              color: '#374151',
              padding: '14px 24px',
              borderRadius: '8px',
              fontWeight: 500,
              fontSize: '15px',
              border: '1px solid #d1d5db',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#f9fafb'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#ffffff'}
          >
            Decline
          </button>
        </div>
        
        <p style={{ color: '#64748b', fontSize: '13px', marginTop: '16px', textAlign: 'center' }}>
          <a href="/privacy-policy" style={{ color: '#2693d0', textDecoration: 'none' }}>View our Privacy Policy</a>
        </p>
      </div>
    </div>
  );
};

export default CookieConsent;
